import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=664a982e&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegistrationForm.vue?vue&type=style&index=1&id=664a982e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a982e",
  null
  
)

export default component.exports